<template>
    <table class="membership-list">
        <thead>
            <tr>
                <th>Member</th>
                <th>Role</th>
                <th v-if="isAdmin" width="150px"></th>
            </tr>
        </thead>
        <tbody>
            <tr class="membership-list__item" v-for="member in sortedMembers" :key="`member-${member.id}`">
                <td class="membership-list__item-name">{{ member.name }} <div class="membership-list__you" v-if="isSelf(member)">(You)</div></td>
                <td>
                    <span class="element-badge is--info" v-if="isOwner(member)">Owner</span>
                    <span class="element-badge is--alt" v-if="!isOwner(member)">Member</span>
                </td>
                <td v-if="isAdmin">
                    <span class="membership-list__item-actions element-table__actions">
                        <button class="element-button--secondary element-button" @click="$emit('promote', member)" v-if="!isOwner(member)">
                            Promote
                        </button>
                        <button class="element-button--secondary element-button" @click="$emit('demote', member)" v-if="isOwner(member)">
                            Demote
                        </button>
                        <button class="element-button--secondary is--alert element-button" @click="$emit('remove', member)">
                            Remove
                        </button>
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import _ from 'lodash'

export default {
    props: {
        isAdmin: {
            type: Boolean,
            default: false
        },
        user: {
            type: Object,
        },
        members: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        userMember () {
            return _.find(this.members, { id: this.user.id })
        },
        pendingMembers () {
            return _.filter(this.members, (member) => member.membership.role_code === 'pending')
        },
        currentMembers () {
            return _.reject(this.members, (member) => member.membership.role_code === 'pending')
        },
        sortedMembers () {
            return _.sortBy(this.currentMembers, (member) => {
                const role = _.get(member, 'membership.role_code')
                if (role === 'owner') {
                    return 'AAA'
                } else if (this.isSelf(member)) {
                    return 'AAB'
                }
                return member.name 
            })
        }
    },
    methods: {
        isSelf (member) {
            return member.id === this.user.id
        },
        isOwner (member) {
            return _.get(member, 'membership.role_code') === 'owner'
        }
    }
}
</script>
